import { CompanyShowType } from '@api';
import { SearchTableInput, useManageTableContext } from '@common';
import { CompanyShowsTable } from '@features';
import { Box, Group, Stack } from '@mantine/core';

type CompanyDetailsShowsPagePropsType = {
  shows: CompanyShowType[];
  isPending: boolean;
};

export const CompanyDetailsShowsPage: React.FC<
  CompanyDetailsShowsPagePropsType
> = ({ shows, isPending }) => {
  const {
    tableArguments: {
      search: { searchValue, setSearchValue },
    },
  } = useManageTableContext();

  return (
    <Stack py="md">
      <Box>
        <Group justify="end" mb="xs">
          <SearchTableInput
            search={searchValue ?? ''}
            setSearchValue={setSearchValue}
          />
        </Group>
        <CompanyShowsTable shows={shows} isPending={isPending} />
      </Box>
    </Stack>
  );
};
